import ImgixPathUrlGenerator from "./PathUrlGenerator/ImgixPathUrlGenerator";

export const getImageUrl = (pathUrlGenerator) => {
	return pathUrlGenerator.build();
}

export const getPathUrlGenerator = (url) => {
	return new ImgixPathUrlGenerator(url);
}